var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 17,
    viewBox: "0 0 24 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 16,
    stroke: "#E6E6FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H23V16H1V1Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 1H23V6H1V1Z",
    fill: "#FF6820"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 11H23V16H1V11Z",
    fill: "#046A38"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9342 10.8125C13.2397 10.8125 14.2981 9.77716 14.2981 8.5C14.2981 7.22284 13.2397 6.1875 11.9342 6.1875C10.6287 6.1875 9.57031 7.22284 9.57031 8.5C9.57031 9.77716 10.6287 10.8125 11.9342 10.8125Z",
    fill: "#07038D"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9351 10.5C13.0642 10.5 13.9795 9.60457 13.9795 8.5C13.9795 7.39543 13.0642 6.5 11.9351 6.5C10.806 6.5 9.89062 7.39543 9.89062 8.5C9.89062 9.60457 10.806 10.5 11.9351 10.5Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9323 8.9001C12.1581 8.9001 12.3412 8.72101 12.3412 8.5001C12.3412 8.27918 12.1581 8.1001 11.9323 8.1001C11.7065 8.1001 11.5234 8.27918 11.5234 8.5001C11.5234 8.72101 11.7065 8.9001 11.9323 8.9001Z",
    fill: "#07038D"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9399 6.50049L12.0166 7.70401L11.9399 8.2999L11.8633 7.70401L11.9399 6.50049Z",
    fill: "#07038D"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1942 6.60436C12.2432 6.61067 12.2881 6.57694 12.2946 6.52903C12.301 6.48112 12.2666 6.43716 12.2176 6.43085C12.1686 6.42455 12.1237 6.45827 12.1172 6.50619C12.1108 6.5541 12.1453 6.59805 12.1942 6.60436Z",
    fill: "#07038D"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.939 10.5005L11.8623 9.29697L11.939 8.70108L12.0156 9.29697L11.939 10.5005Z",
    fill: "#07038D"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6847 10.3966C11.6357 10.3903 11.5908 10.424 11.5843 10.4719C11.5779 10.5199 11.6123 10.5638 11.6613 10.5701C11.7103 10.5764 11.7552 10.5427 11.7617 10.4948C11.7681 10.4469 11.7336 10.4029 11.6847 10.3966Z",
    fill: "#07038D"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4671 6.56825L12.2194 7.75033L11.9882 8.30731L12.0742 7.71247L12.4671 6.56825Z",
    fill: "#07038D"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6847 6.73416C12.7301 6.75242 12.7824 6.73084 12.8016 6.68596C12.8207 6.64108 12.7995 6.58989 12.7541 6.57163C12.7087 6.55338 12.6564 6.57496 12.6372 6.61984C12.6181 6.66472 12.6393 6.7159 12.6847 6.73416Z",
    fill: "#07038D"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4079 10.4327L11.6556 9.25064L11.8868 8.69367L11.8008 9.2885L11.4079 10.4327Z",
    fill: "#07038D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1903 10.2668C11.1449 10.2486 11.0926 10.2701 11.0734 10.315C11.0543 10.3599 11.0755 10.4111 11.1209 10.4293C11.1663 10.4476 11.2186 10.426 11.2378 10.3811C11.2569 10.3363 11.2357 10.2851 11.1903 10.2668Z",
    fill: "#07038D"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9602 6.76754L12.4099 7.84747L12.0392 8.32673L12.2785 7.77332L12.9602 6.76754Z",
    fill: "#07038D"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1251 6.98295C13.1641 7.01219 13.2203 7.00467 13.2505 6.96616C13.2808 6.92764 13.2737 6.87271 13.2347 6.84347C13.1957 6.81423 13.1395 6.82175 13.1093 6.86027C13.079 6.89879 13.0861 6.95371 13.1251 6.98295Z",
    fill: "#07038D"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9109 10.2325L11.4612 9.15253L11.8319 8.67327L11.5926 9.22668L10.9109 10.2325Z",
    fill: "#07038D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M10.746 10.017C10.707 9.98781 10.6508 9.99533 10.6206 10.0338C10.5903 10.0724 10.5974 10.1273 10.6364 10.1565C10.6754 10.1858 10.7316 10.1782 10.7618 10.1397C10.7921 10.1012 10.785 10.0463 10.746 10.017Z",
    fill: "#07038D"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3819 7.08529L12.565 7.98949L12.0803 8.35859L12.4576 7.88435L13.3819 7.08529Z",
    fill: "#07038D"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4858 7.3364C13.5157 7.37458 13.5719 7.38155 13.6112 7.35196C13.6506 7.32238 13.6583 7.26745 13.6284 7.22928C13.5985 7.1911 13.5423 7.18414 13.503 7.21372C13.4636 7.2433 13.4559 7.29823 13.4858 7.3364Z",
    fill: "#07038D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4892 9.9152L11.3061 9.01099L11.7908 8.6419L11.4135 9.11614L10.4892 9.9152Z",
    fill: "#07038D"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3853 9.66408C10.3554 9.62591 10.2992 9.61894 10.2599 9.64852C10.2205 9.67811 10.2128 9.73303 10.2427 9.77121C10.2726 9.80938 10.3288 9.81635 10.3681 9.78677C10.4075 9.75719 10.4152 9.70226 10.3853 9.66408Z",
    fill: "#07038D"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7067 7.50118L12.6807 8.16766L12.1147 8.39952L12.6031 8.03639L13.7067 7.50118Z",
    fill: "#07038D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7411 7.76807C13.7602 7.81291 13.8125 7.83442 13.858 7.81612C13.9034 7.79782 13.9248 7.74663 13.9057 7.70179C13.8866 7.65695 13.8343 7.63544 13.7888 7.65374C13.7434 7.67204 13.722 7.72323 13.7411 7.76807Z",
    fill: "#07038D"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1644 9.49979L11.1904 8.83331L11.7564 8.60145L11.268 8.96458L10.1644 9.49979Z",
    fill: "#07038D"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.13 9.23291C10.1109 9.18807 10.0586 9.16656 10.0131 9.18486C9.96767 9.20316 9.94631 9.25435 9.96542 9.29918C9.98452 9.34402 10.0368 9.36553 10.0823 9.34723C10.1277 9.32893 10.1491 9.27775 10.13 9.23291Z",
    fill: "#07038D"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9068 7.98336L12.7389 8.36704L12.1306 8.44756L12.6987 8.22063L13.9068 7.98336Z",
    fill: "#07038D"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8703 8.25044C13.8769 8.2985 13.9218 8.33246 13.9706 8.3263C14.0195 8.32014 14.0537 8.27619 14.0471 8.22813C14.0405 8.18007 13.9956 8.14611 13.9467 8.15227C13.8979 8.15843 13.8637 8.20238 13.8703 8.25044Z",
    fill: "#07038D"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95646 9.01761L11.1243 8.63393L11.7327 8.55342L11.1646 8.78034L9.95646 9.01761Z",
    fill: "#07038D"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M9.993 8.75054C9.98641 8.70248 9.94148 8.66851 9.89265 8.67467C9.84382 8.68083 9.80959 8.72479 9.81618 8.77285C9.82278 8.8209 9.86771 8.85487 9.91654 8.84871C9.96536 8.84255 9.9996 8.7986 9.993 8.75054Z",
    fill: "#07038D"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9769 8.50378L12.7476 8.5698L12.1383 8.4961L12.7468 8.42748L13.9769 8.50378Z",
    fill: "#07038D"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8731 8.7494C13.8668 8.79712 13.9017 8.84107 13.9509 8.84757C14.0001 8.85407 14.045 8.82065 14.0512 8.77293C14.0575 8.72521 14.0226 8.68126 13.9734 8.67476C13.9242 8.66826 13.8793 8.70168 13.8731 8.7494Z",
    fill: "#07038D"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M9.89024 8.49671L11.1196 8.43069L11.7289 8.50439L11.1204 8.57301L9.89024 8.49671Z",
    fill: "#07038D"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M9.99413 8.25109C10.0004 8.20337 9.96551 8.15942 9.91631 8.15292C9.86711 8.14642 9.82218 8.17984 9.81595 8.22756C9.80973 8.27528 9.84457 8.31923 9.89377 8.32573C9.94298 8.33223 9.98791 8.29881 9.99413 8.25109Z",
    fill: "#07038D"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M13.906 9.01864L12.6978 8.77936L12.1292 8.55272L12.7374 8.63466L13.906 9.01864Z",
    fill: "#07038D"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M13.738 9.23253C13.7191 9.27716 13.7408 9.32835 13.7865 9.34685C13.8321 9.36536 13.8844 9.34419 13.9033 9.29956C13.9222 9.25493 13.9005 9.20374 13.8548 9.18524C13.8092 9.16673 13.7568 9.1879 13.738 9.23253Z",
    fill: "#07038D"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M9.95729 7.98283L11.1655 8.22211L11.7341 8.44875L11.1259 8.3668L9.95729 7.98283Z",
    fill: "#07038D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1253 7.76893C10.1442 7.7243 10.1225 7.67312 10.0768 7.65461C10.0312 7.6361 9.97884 7.65728 9.95996 7.70191C9.94108 7.74654 9.9628 7.79772 10.0085 7.81623C10.0541 7.83474 10.1065 7.81356 10.1253 7.76893Z",
    fill: "#07038D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6995 9.49972L12.5959 8.96451L12.1074 8.60138L12.6734 8.83323L13.6995 9.49972Z",
    fill: "#07038D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4797 9.66503C13.4495 9.70354 13.4566 9.75847 13.4956 9.78771C13.5346 9.81695 13.5907 9.80943 13.621 9.77091C13.6513 9.7324 13.6442 9.67747 13.6052 9.64823C13.5661 9.61899 13.51 9.62651 13.4797 9.66503Z",
    fill: "#07038D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1599 7.50028L11.2635 8.03549L11.752 8.39862L11.1859 8.16677L10.1599 7.50028Z",
    fill: "#07038D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M10.3796 7.33497C10.4099 7.29646 10.4028 7.24153 10.3638 7.21229C10.3248 7.18305 10.2686 7.19057 10.2384 7.22909C10.2081 7.2676 10.2152 7.32253 10.2542 7.35177C10.2932 7.38101 10.3494 7.37349 10.3796 7.33497Z",
    fill: "#07038D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3749 9.91342L12.451 9.11664L12.0754 8.64208L12.5605 9.00954L13.3749 9.91342Z",
    fill: "#07038D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1213 10.0175C13.0819 10.0471 13.0742 10.102 13.1041 10.1402C13.134 10.1783 13.1901 10.1852 13.2295 10.1556C13.2689 10.126 13.2766 10.0711 13.2467 10.033C13.2168 9.9948 13.1606 9.98787 13.1213 10.0175Z",
    fill: "#07038D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4805 7.08658L11.4045 7.88336L11.7801 8.35792L11.295 7.99046L10.4805 7.08658Z",
    fill: "#07038D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7342 6.98253C10.7736 6.95293 10.7813 6.898 10.7514 6.85985C10.7215 6.82169 10.6654 6.81475 10.626 6.84435C10.5866 6.87395 10.5789 6.92888 10.6088 6.96704C10.6387 7.0052 10.6948 7.01213 10.7342 6.98253Z",
    fill: "#07038D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9489 10.232L12.2675 9.22776L12.0299 8.67413L12.401 9.15234L12.9489 10.232Z",
    fill: "#07038D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6733 10.2673C12.6276 10.2859 12.6057 10.3371 12.6245 10.3817C12.6433 10.4262 12.6957 10.4473 12.7414 10.4287C12.7871 10.4101 12.809 10.3589 12.7902 10.3144C12.7714 10.2698 12.719 10.2488 12.6733 10.2673Z",
    fill: "#07038D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9027 6.76844L11.5841 7.77273L11.8217 8.32636L11.4506 7.84815L10.9027 6.76844Z",
    fill: "#07038D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1783 6.73315C11.224 6.71456 11.2458 6.66338 11.227 6.61883C11.2082 6.57427 11.1559 6.55323 11.1102 6.57181C11.0644 6.5904 11.0426 6.64159 11.0614 6.68614C11.0802 6.73069 11.1325 6.75174 11.1783 6.73315Z",
    fill: "#07038D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4529 10.4321L12.0606 9.28928L11.9776 8.69425L12.2094 9.25024L12.4529 10.4321Z",
    fill: "#07038D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1811 10.3964C12.132 10.4027 12.0974 10.4467 12.1038 10.4945C12.1102 10.5424 12.1551 10.576 12.2042 10.5696C12.2532 10.5633 12.2878 10.5193 12.2814 10.4715C12.275 10.4236 12.2301 10.39 12.1811 10.3964Z",
    fill: "#07038D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3986 6.56837L11.791 7.7112L11.874 8.30624L11.6422 7.75025L11.3986 6.56837Z",
    fill: "#07038D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6705 6.60412C11.7195 6.59775 11.7541 6.55379 11.7478 6.50594C11.7414 6.4581 11.6964 6.42447 11.6474 6.43085C11.5984 6.43722 11.5638 6.48117 11.5701 6.52902C11.5765 6.57687 11.6215 6.61049 11.6705 6.60412Z",
    fill: "#07038D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInr);
export default __webpack_public_path__ + "static/media/INR.214037dce8e74a74e82307c60c18aec6.svg";
export { ForwardRef as ReactComponent };